module.exports = __webpack_public_path__ + "static/Product-Online-Fullframe-1.39b7de26.jpg";